<interacta-menu-dialog
    [open]="isOpen()"
    [origin]="origin()"
    [overridePositions]="overridePositions()"
    (closing)="onClosing()"
>
    <div class="max-h-screen w-min min-w-252 p-16" interactaMenuDecorator>
        @switch (currentPage()) {
            @case ('home') {
                <div
                    animate.enter="animate-slide-in"
                    cdkTrapFocus
                    cdkTrapFocusAutoCapture
                    class="flex flex-col slide-from-left-lg motion-reduce:animate-none"
                    role="menu"
                >
                    @if (userSubtitle(); as subtitle) {
                        <div class="flex items-center gap-12">
                            <div class="flex flex-1 flex-col">
                                <span class="typo-sm-bold">
                                    {{ currentUser().fullName }}
                                </span>
                                <span class="typo-xs text-text-mid-contrast">
                                    {{ subtitle }}
                                </span>
                            </div>
                            <interacta-avatar [user]="currentUser()" />
                        </div>
                    } @else {
                        <interacta-user
                            class="ml-auto w-max"
                            [rtl]="true"
                            [showInfo]="true"
                            [user]="currentUser()"
                        />
                    }

                    <interacta-user-menu-separator />

                    @if (currentLanguage(); as lang) {
                        <button
                            aria-expanded="false"
                            aria-haspopup="menu"
                            cdkFocusInitial
                            interacta-user-menu-button
                            role="menuitem"
                            type="button"
                            [icon]="'translate'"
                            [withArrow]="true"
                            (click)="currentPage.set('language')"
                        >
                            {{ 'SHARED.USER_MENU.LANGUAGE' | translate }}
                            <span class="ml-4 text-text-primary">
                                {{ lang.description }}
                            </span>
                        </button>
                    }

                    <button
                        aria-expanded="false"
                        aria-haspopup="menu"
                        interacta-user-menu-button
                        role="menuitem"
                        type="button"
                        [icon]="themeIcon()"
                        [withArrow]="true"
                        (click)="currentPage.set('theme')"
                    >
                        {{ 'SHARED.USER_MENU.THEME' | translate }}
                        <span class="ml-4 text-text-primary">
                            {{ themeLabel() | translate }}
                        </span>
                    </button>

                    <interacta-user-menu-separator />

                    <ng-content select="[userMenuExtraItems]" />

                    <button
                        interacta-user-menu-button
                        role="menuitem"
                        type="button"
                        [icon]="'check-circle-indeterminate'"
                        (click)="onLogout()"
                    >
                        {{ 'SHARED.LOGOUT' | translate }}
                    </button>
                </div>
            }
            @case ('theme') {
                <interacta-user-menu-theme
                    animate.enter="animate-slide-in"
                    cdkTrapFocus
                    cdkTrapFocusAutoCapture
                    class="block slide-from-right-lg motion-reduce:animate-none"
                    role="menu"
                    [currentTheme]="currentTheme()"
                    (back)="currentPage.set('home')"
                    (changeTheme)="changeTheme.emit($event)"
                />
            }
            @case ('language') {
                @if (currentLanguage(); as lang) {
                    <interacta-user-menu-language
                        animate.enter="animate-slide-in"
                        cdkTrapFocus
                        cdkTrapFocusAutoCapture
                        class="block slide-from-right-lg motion-reduce:animate-none"
                        role="menu"
                        [availableLanguages]="availableLanguages()"
                        [currentLanguage]="lang"
                        (back)="currentPage.set('home')"
                        (changeLanguage)="changeLanguage.emit($event)"
                    />
                }
            }
        }
    </div>
</interacta-menu-dialog>
